var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDerslikler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.33218V3.0578H12.5567L9.47308 7.37187H11.6681V9.09749H10.2995L13.5964 16H11.6414L10.8149 14.2744H3.11918L2.20387 16H0.204391L3.87454 9.09749H3.67015C3.27026 9.09749 2.93257 8.83865 2.81704 8.49353L0 0.331313L0.844224 0.0379561C1.30633 -0.100094 1.81286 0.150122 1.96393 0.598785L4.30998 7.37187H8.2023L11.2859 3.0578H8.11343V1.33218H17ZM5.89179 9.09749L4.04339 12.5487H9.9885L8.34449 9.09749H5.89179Z",
    fill: "#FFE5BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDerslikler);
export default __webpack_public_path__ + "static/media/derslikler.df1c1454d25731ac54b748b9d3b8a296.svg";
export { ForwardRef as ReactComponent };